import React, { useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

import "../../styles/PaymentStep.css";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoaderModal from "../LoaderModal";

const PaymentStep = ({ amount, createdOrderId }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      console.error("Stripe.js has not yet loaded.");
      return;
    }
    const cardElement = elements.getElement(CardElement);
    // console.log(cardElement);
    if (!cardElement) {
      console.error("CardElement not found.");
      return;
    }
    const amountInCents = Math.round(amount * 100);

    setLoading(true);
    const response = await fetch("/stripe/pay", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ amount: amountInCents, orderId: createdOrderId }),
    });
    const data = await response.json();
    // console.log("data", data);

    const confirmPayment = await stripe.confirmCardPayment(data.clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });
    const { paymentIntent, error } = await confirmPayment;
    if (error) {
      console.error("Payment failed:", error.message);
    }
    // console.log("Payment intent:", paymentIntent);
    if (error) {
      navigate(`/order/confirm/${createdOrderId}`, {
        state: {
          isStripe: true,
          paymentSuccess: false,
          error: error.message,
          // error: paymentIntent.last_payment_error.message,
        },
      });
      toast.error("Payment Failed");
      setLoading(false);
    } else if (paymentIntent) {
      if (paymentIntent?.status === "succeeded") {
        //   toast.success("Payment Successful");
        toast.success("Payment Successful");
        setLoading(false);
        navigate(`/order/confirm/${createdOrderId}`, {
          state: {
            isStripe: true,
            paymentSuccess: true,
            transactionId: paymentIntent?.id,
            amountPaid: paymentIntent?.amount / 100,
          },
        });
      }
    } else {
      //   toast.error("Payment Failed");
      navigate(`/order/confirm/${createdOrderId}`, {
        state: {
          isStripe: true,
          paymentSuccess: false,
          error: paymentIntent.last_payment_error.message,
        },
      });
      toast.error("Payment Failed");
      setLoading(false);
    }
  };
  return (
    <div className="mb-4 p-6 mx-auto bg-white shadow-lg rounded-xl max-w-md payment-container">
      <h3 className="text-2xl font-semibold text-center mb-6 text-gray-100">
        Enter Payment Details
      </h3>
      {/* <div className="mb-4">
        <label className="block text-white text-lg mb-2">Card Details</label>

        <div className="mb-3">
          <CardNumberElement
            options={{
              style: {
                base: {
                  fontSize: "18px",
                  color: "white",
                  fontFamily: "Arial, sans-serif",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
            className="border border-gray-300 p-3 rounded-md w-full"
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <CardExpiryElement
            options={{
              style: {
                base: {
                  fontSize: "18px",
                  color: "white",
                  fontFamily: "Arial, sans-serif",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
            className="border border-gray-300 p-3 rounded-md flex-1"
          />
          <CardCvcElement
            options={{
              style: {
                base: {
                  fontSize: "18px",
                  color: "white",
                  fontFamily: "Arial, sans-serif",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
            className="border border-gray-300 p-3 rounded-md flex-1"
          />
        </div>
      </div>  */}

      <div className="mb-4">
        <label className="block text-white text-lg mb-2">Card Details</label>
        <CardElement
          options={{
            style: {
              base: {
                fontSize: "18px",
                color: "white",
                // color: "#424770",
                fontFamily: "Arial, sans-serif",
                "::placeholder": {
                  color: "#aab7c4",
                },
              },
              invalid: {
                color: "#9e2146",
              },
            },
          }}
          className="border border-gray-300 p-3 rounded-md transition-shadow duration-300 focus:border-blue-400 focus:shadow-md"
        />
      </div>
      {!loading ? (
        <Button
          label="Pay"
          className="p-button-rounded p-button-primary w-full text-lg font-medium fw-bold"
          onClick={handlePaymentSubmit}
          style={{ padding: "0.75rem", marginTop: "1rem", fontWeight: "bold" }}
        />
      ) : (
        <LoaderModal modalShow={loading} />
      )}
    </div>
  );
};

export default PaymentStep;

// <div
//   className="mb-4"
//   style={{
//     borderRadius: "10px",
//     padding: "20px",
//     margin: "auto",
//     boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//   }}
// >
//   <h3 className="payment-step-title">Enter Payment Details</h3>
//   <div className="input-container">
//     <label>Card Details</label>
//     <CardElement
//       options={{
//         style: {
//           base: {
//             fontSize: "18px",
//             color: "#424770",
//             "::placeholder": {
//               color: "#aab7c4",
//             },
//           },
//           invalid: {
//             color: "#9e2146",
//           },
//         },
//       }}
//     />
//     <Button
//       label="Pay"
//       className="p-button-rounded p-button-success payment-step-button"
//       onClick={handlePaymentSubmit}
//     />
//   </div>
// </div>

// import React from "react";
// import "../../styles/PaymentStep.css";

// const PaymentStep = ({ handleChange, input }) => {
//   return (
//     <div
//       className="mb-4"
//       style={{
//         borderRadius: "10px",
//         padding: "20px",
//         margin: "auto",
//         boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//       }}
//     >
//       <h3 className="payment-step-title">Enter Payment Details</h3>
//       <div className="input-container">
//         <label>Card Number</label>
//         <input
//           type="text"
//           placeholder="Card Number"
//           name="cardNumber"
//           value={input.cardNumber}
//           onChange={handleChange}
//           className="payment-input"
//           required
//         />
//       </div>
//       <div
//         style={{ display: "flex", alignItems: "center" }}
//         className="input-container"
//       >
//         <label>Card Expiry (MM/YY): </label>
//         {"  "}
//         <div>
//           <input
//             type="text"
//             name="cardExpiryMonth"
//             value={input.cardExpiryMonth}
//             onChange={handleChange}
//             placeholder="MM"
//             min="1"
//             max="12"
//             style={{
//               width: "3rem",
//               marginRight: "0.5rem",
//               marginLeft: "0.1rem",
//             }}
//             maxLength="2"
//             required
//           />
//           /
//           <input
//             type="text"
//             // value={year}
//             name="cardExpiryYear"
//             value={input.cardExpiryYear}
//             onChange={handleChange}
//             // onChange={handleYearChange}
//             placeholder="YY"
//             min="0"
//             max="99"
//             style={{ width: "3rem", marginLeft: "0.5rem" }}
//             maxLength="2"
//             required
//           />
//         </div>
//       </div>
//       {/* <div className="input-container">
//         <label>Expiry Date (MM/YY):</label>
//         <input
//           type="text"
//           value={expiry}
//           onChange={handleExpiryChange}
//           placeholder="MM/YY"
//           maxLength="5"
//           className="payment-input"
//           required
//         />
//       </div> */}
//       <div className="input-container">
//         <label>CVV</label>
//         <input
//           type="password"
//           placeholder="CVV"
//           value={input.cardCVV}
//           name="cardCVV"
//           onChange={handleChange}
//           className="payment-input"
//           required
//         />
//       </div>
//     </div>
//   );
// };

// export default PaymentStep;
